export const TEST_STEPS_REQUEST = 'TEST_STEPS_REQUEST';
export const TEST_STEPS_COMPLETE = 'TEST_STEPS_COMPLETE';
export const TEST_STEPS_ERROR = 'TEST_STEPS_ERROR';

export const SAVE_ANSWERS_COMPLETE = 'SAVE_ANSWERS_COMPLETE';
export const TEST_START_COMPLETE = 'TEST_START_COMPLETE';

export const TEST_SUBMIT_REQUEST = 'TEST_SUBMIT_REQUEST'
export const TEST_SUBMIT_COMPLETE = 'TEST_SUBMIT_COMPLETE'
export const TEST_SUBMIT_ERROR = 'TEST_SUBMIT_ERROR'

export const TEST_FAILED_COMPLETE = 'TEST_FAILED_COMPLETE'



// WEBPACK FOOTER //
// ./src/store/test/actionTypes.js